var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"lg":"12"}},[_c('ApexChart',{attrs:{"element":_vm.type,"chartOption":_vm.bodyData}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }